// @flow
// eslint-disable-next-line project-structure/folder-structure
import * as header from 'config/common/header.json';
import * as partnerRecommendation from 'config/common/partnerRecommendation.json';
import * as tuiOrganizer from 'config/common/tuiOrganizers.json';
import * as vouchers from 'config/common/vouchers.json';
import * as hotelDetails from 'config/common/hotelDetails.json';
import * as tourOperators from 'config/common/tourOperators.json';

export default {
  header: header.default,
  tuiOrganizers: tuiOrganizer.default,
  vouchers,
  partnerRecommendation,
  hotelDetails: hotelDetails.default,
  tourOperators,
};
